import Image from 'next/image';
import { useRef } from 'react';

import { InputField } from 'common';
import { Icon } from 'common/icon';
import { IUser } from 'constants/types';
import { Formik } from 'formik';
import { useClickOutside } from 'hooks/useClickOutside';
import { ModalMain } from '../main';
import { initialValues, model, validationSchema } from './config';

import styles from './styles.module.css';
import { useSocialAccounts } from 'hooks/useSocialsAccounts';
import clsx from 'clsx';
import { GoogleButton } from './social-buttons';
import { Button } from 'common/new-button';

interface EditProfileModalProps {
  data?: IUser;
  isVisible: boolean;
  onClose?: () => void;
  onEditEmail: () => void;
  onEditPhoto: () => void;
  onEditUsername: () => void;
  onUnlinkGoogle: () => void;
}

export const EditProfileModal = ({
  data,
  onClose,
  isVisible,
  onEditEmail,
  onEditPhoto,
  onEditUsername,
  onUnlinkGoogle,
}: EditProfileModalProps) => {
  const modalRef = useRef<HTMLDivElement | null>(null);

  useClickOutside({ onClick: onClose, ref: modalRef });

  const { linkGoogle } = useSocialAccounts();
  const classesGoogleBtn = clsx(styles.button, styles.google);

  const settingsGoogle = {
    className: classesGoogleBtn,
    text: 'Unlink Google',
    icon: <Icon.Google />,
  };

  return (
    <ModalMain
      title=""
      footer=""
      width={260}
      targetRef={modalRef}
      isVisible={isVisible}
      closeOnClick={onClose}
    >
      <Formik
        onSubmit={() => {}}
        initialValues={initialValues(data)}
        validationSchema={validationSchema}
        enableReinitialize
      >
        {({}) => (
          <div className={styles.body}>
            <div className={styles.wrapper_header}>
              <span>{'Edit profile'}</span>
              <div className={styles.iconClose} onClick={onClose}>
                <Icon.Close />
              </div>
            </div>
            <div className={styles.wrapper_content}>
              <div className={styles.wrapper_input}>
                <div onClick={onEditPhoto} className={styles.update_photo}>
                  <InputField {...model.userPhoto} />
                  <div className={styles.wrapper_image}>
                    <Image
                      src={data?.imageUrl ?? ''}
                      className={styles.image}
                      width={30}
                      height={30}
                      alt="user"
                    />
                    <span className={styles.image_name}>
                      {'Update avatar...'}
                    </span>
                  </div>
                </div>
                <div className={styles.wrapper_icon} onClick={onEditPhoto}>
                  <Icon.Edit fill="#121212" />
                </div>
              </div>
              <div onClick={onEditEmail} className={styles.wrapper_input}>
                <InputField
                  {...model.email}
                  variant="editProfile"
                  className={styles.iconClose}
                />
                <div className={styles.wrapper_icon}>
                  <Icon.Edit fill="#121212" />
                </div>
              </div>
              <div onClick={onEditUsername} className={styles.wrapper_input}>
                <InputField
                  {...model.username}
                  variant="editProfile"
                  className={styles.iconClose}
                />
                <div className={styles.wrapper_icon} onClick={onEditUsername}>
                  <Icon.Edit fill="#121212" />
                </div>
              </div>
              {data?.googleId ? (
                <Button {...settingsGoogle} onClick={onUnlinkGoogle} />
              ) : (
                <GoogleButton
                  className={settingsGoogle.className}
                  onSuccess={(oauthToken) => linkGoogle({ oauthToken })}
                />
              )}
            </div>
          </div>
        )}
      </Formik>
    </ModalMain>
  );
};
